module.exports = __webpack_public_path__ + "c740a4295da49876d8e1e2bf3f9bb5e4.png";